import { initWindows, windowsToggle } from '../components/windows';

/**
 * This function toggles the visibility of filters on a webpage when a button is clicked.
 * @returns The function `showOrHideFilters` returns nothing (`undefined`) if the `btnDesktop` element
 * is not found.
 */
const showOrHideFilters = () => {
  const btnDesktop = document.querySelector('#filter-open-desktop-js');

  if (!btnDesktop) return;

  const textDesktop = document.querySelector('#filter-open-desktop-text-js');
  const filtersDesktop = document.querySelector('.products-container__accordions-js');

  btnDesktop.addEventListener('click', () => {
    filtersDesktop.classList.toggle('hidden');
    const newTextFilter = filtersDesktop.classList.contains('hidden')
      ? textDesktop.dataset.show
      : textDesktop.dataset.hidden;

    textDesktop.innerHTML = newTextFilter;
  })
}

/**
 * The function initializes and shows/hides filters based on user interaction.
 */
export const initFilter = () => {
  const btnMobile = document.querySelector('#filter-open-js');

  if (!btnMobile) return;

  windowsToggle({ scope: '#nav-filters-js' })

  initWindows({
    control: '#filter-open-js',
    target: '#nav-filters-js',
  });

  showOrHideFilters();
}
